var _circle, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOkShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EAEAF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(8 8)",
    fill: "#EAEAF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9857 20.3411C17.0504 20.3411 14.6107 17.9951 14.6107 15.2191C14.6107 12.347 17.0504 10 19.9867 10C23.0227 10 25.3616 12.346 25.3616 15.2191C25.3564 16.5821 24.789 17.8874 23.7843 18.8481C22.7795 19.8087 21.4196 20.3461 20.0033 20.3421L19.9857 20.3411ZM19.9857 13.017C18.743 13.017 17.7975 14.022 17.7975 15.2201C17.7975 16.4161 18.743 17.3261 19.9867 17.3261C21.2803 17.3261 22.1759 16.4161 22.1759 15.2201C22.177 14.021 21.2803 13.017 19.9857 13.017ZM22.1261 24.6032L25.1631 27.4282C25.7606 28.0492 25.7606 28.9592 25.1631 29.5342C24.5169 30.1553 23.5204 30.1553 23.0227 29.5342L19.9867 26.6612L17.0504 29.5342C16.7522 29.8212 16.3532 29.9642 15.9043 29.9642C15.5563 29.9642 15.1583 29.8202 14.8092 29.5342C14.2118 28.9592 14.2118 28.0492 14.8092 27.4272L17.8951 24.6022C16.7807 24.2846 15.7116 23.8348 14.7126 23.2632C13.9655 22.8802 13.8169 21.9231 14.2149 21.2041C14.7126 20.4861 15.6082 20.2951 16.4052 20.7741C17.4843 21.408 18.724 21.7433 19.9883 21.7433C21.2525 21.7433 22.4922 21.408 23.5713 20.7741C24.3683 20.2951 25.3128 20.4861 25.7606 21.2041C26.2094 21.9231 26.0089 22.8792 25.3117 23.2632C24.3672 23.8382 23.2721 24.2692 22.1271 24.6042L22.1261 24.6032Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkShare);
export default __webpack_public_path__ + "static/media/okShare.a8e3d928f1f9d0935d29eba9d1afdbcd.svg";
export { ForwardRef as ReactComponent };